/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
import type { PostProcessingStatusEnum } from "./PostProcessingStatusEnum";
import {
  PostProcessingStatusEnumFromJSON,
  PostProcessingStatusEnumFromJSONTyped,
  PostProcessingStatusEnumToJSON,
  PostProcessingStatusEnumToJSONTyped,
} from "./PostProcessingStatusEnum";

/**
 * A type of `ModelSerializer` that uses
 * hyperlinked relationships with compound keys instead
 * of primary key relationships.  Specifically:
 * * A 'url' field is included instead of the 'id' field.
 * * Relationships to other instances are hyperlinks, instead of primary keys.
 * NOTE: this only works with DRF 3.1.0 and above.
 * @export
 * @interface PostProcessingStatusHistory
 */
export interface PostProcessingStatusHistory {
  /**
   *
   */
  readonly simulation?: string;
  /**
   *
   */
  status: PostProcessingStatusEnum;
  /**
   *
   */
  readonly created?: Date;
}

/**
 * Check if a given object implements the PostProcessingStatusHistory interface.
 */
export function instanceOfPostProcessingStatusHistory(
  value: object
): value is PostProcessingStatusHistory {
  if (!("status" in value) || value["status"] === undefined) return false;
  return true;
}

export function PostProcessingStatusHistoryFromJSON(json: any): PostProcessingStatusHistory {
  return PostProcessingStatusHistoryFromJSONTyped(json, false);
}

export function PostProcessingStatusHistoryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PostProcessingStatusHistory {
  if (json == null) {
    return json;
  }
  return {
    simulation: json["simulation"] == null ? undefined : json["simulation"],
    status: PostProcessingStatusEnumFromJSON(json["status"]),
    created: json["created"] == null ? undefined : parseDateTime(json["created"]),
  };
}

export function PostProcessingStatusHistoryToJSON(json: any): PostProcessingStatusHistory {
  return PostProcessingStatusHistoryToJSONTyped(json, false);
}

export function PostProcessingStatusHistoryToJSONTyped(
  value?: Omit<PostProcessingStatusHistory, "simulation" | "created"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    status: PostProcessingStatusEnumToJSON(value["status"]),
  };
}
